import { eDmMucHocPhiTinChiActionsObj } from "./../../action-types/category/IDmMucHocPhiTinChiActions";
import { NotifyHelper } from "../../../helpers/toast";
import { eDmMucHocPhiTinChiActionIds } from "../../action-types/category/IDmMucHocPhiTinChiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const mucHocPhiTinChiActions = {
  ...generateActions(eDmMucHocPhiTinChiActionsObj, "MUC_HOC_PHI_TIN_CHI"),
  ...generateActionForKey(
    eDmMucHocPhiTinChiActionIds,
    "MUC_HOC_PHI_TIN_CHI",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eDmMucHocPhiTinChiActionIds,
    "MUC_HOC_PHI_TIN_CHI",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmMucHocPhiTinChiActionIds,
    "MUC_HOC_PHI_TIN_CHI",
    "LOCK_SUCCESS",
    (m: string) => {
      NotifyHelper.Success("Khoá thành công");
    }
  ),
  ...generateActionForKey(
    eDmMucHocPhiTinChiActionIds,
    "MUC_HOC_PHI_TIN_CHI",
    "LOCK_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmMucHocPhiTinChiActionIds,
    "MUC_HOC_PHI_TIN_CHI",
    "UNLOCK_SUCCESS",
    (m: string) => {
      NotifyHelper.Success("Mở khóa thành công");
    }
  ),
  ...generateActionForKey(
    eDmMucHocPhiTinChiActionIds,
    "MUC_HOC_PHI_TIN_CHI",
    "UNLOCK_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmMucHocPhiTinChiActionIds,
    "MUC_HOC_PHI_TIN_CHI",
    "COPY_ERROR",
    (m: string) => {
      NotifyHelper.Error("Sao chép không thành công");
    }
  ),
  ...generateActionForKey(
    eDmMucHocPhiTinChiActionIds,
    "MUC_HOC_PHI_TIN_CHI",
    "COPY_SUCCESS",
    () => {
      NotifyHelper.Success("Sao chép thành công");
    }
  ),
};
